module.exports = __webpack_public_path__ + "img/LOADING_bsplogo_02_d4c758c39.png";